import hljsVuePlugin from '@highlightjs/vue-plugin'
import * as Sentry from '@sentry/vue'
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmPopup from 'primevue/confirmpopup'
import FocusTrap from 'primevue/focustrap'
import Ripple from 'primevue/ripple'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css'
import 'flag-icons/css/flag-icons.min.css'
import NoPrint from './directives/noPrint'
import { auth0 } from './plugins/auth'
import FontAwesomeIcon from './plugins/icons'
// @ts-expect-error: no type declaration
import Nomic from './presets/nomic'
import { createRouter, setPageTitleGuard } from './router'
import { setStaleBuildReloadGuard } from './router/staleBuild'

hljs.registerLanguage('json', json)

const app = createApp(App)
const router = createRouter()

Sentry.init({
  app,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  beforeBreadcrumb: (breadcrumb, hint) => {
    if (breadcrumb.category === 'console') {
      return breadcrumb // Keep all console logs
    }
    return breadcrumb
  },
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [Sentry.browserTracingIntegration({ router })],
  sendDefaultPii: false
})

setPageTitleGuard(router)
setStaleBuildReloadGuard(router)

app
  .use(router) // this must be before auth0 or redirects won't work
  .use(auth0)
  .use(createPinia())
  .use(hljsVuePlugin)
  .use(PrimeVue, { unstyled: true, pt: Nomic })
  .use(ConfirmationService)
  .use(ToastService)
  .component('Icon', FontAwesomeIcon)
  .component('ConfirmDialog', ConfirmDialog)
  .component('ConfirmPopup', ConfirmPopup)
  .mount('#app')

app.directive('no-print', NoPrint)
app.directive('tooltip', Tooltip)
app.directive('focustrap', FocusTrap)
app.directive('ripple', Ripple)
